<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="#3D6A8C"
          :title="$t('UserAccount.heading')"
          :text="$t('UserAccount.subHeading')"
        >
          <aurora-user-account :user-account="userAccount" />
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { auth } from 'vuetify-aurora';

export default {
  mixins: [auth],
};
</script>
